"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.from");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.map");

require("core-js/modules/es.array.reduce");

require("core-js/modules/es.array.slice");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.entries");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.string.replace");

require("core-js/modules/es.string.split");

require("core-js/modules/es.string.trim");

require("core-js/modules/web.dom-collections.for-each");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _dompurify = _interopRequireDefault(require("dompurify"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var KEY_SEPERATOR = '__';

var FormUtils = /*#__PURE__*/function () {
  function FormUtils() {
    _classCallCheck(this, FormUtils);
  }

  _createClass(FormUtils, null, [{
    key: "formToStoreObject",

    /**
     * Form data is in the format:
     * {
     * 	`{sectionId}__{fieldId1}`: value,
     * 	`{sectionId}__{fieldId2}`: value
     * 	 }
     *
     * Store data is in the format:
     * {
     * 		sectionId: {
     * 			fieldId1`: value,
     * 			fieldId2`: value,
     * 		}
     * 	 }
     *
     * This utility will take a form data object and return a new object in the store format.
     *
     * @param {Object} formData (form.values())
     * @param {boolean} skipSanitize
     * @returns {Object}
     */
    value: function formToStoreObject(formData) {
      var skipSanitize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var storeObject = {};
      Object.keys(formData).forEach(function (key) {
        if (formData.hasOwnProperty(key)) {
          var splitKey = key.split(KEY_SEPERATOR);

          if (!storeObject[splitKey[0]]) {
            storeObject[splitKey[0]] = {};
          }

          storeObject[splitKey[0]][splitKey[1]] = typeof formData[key] === 'string' ? skipSanitize ? formData[key].trim() : _dompurify.default.sanitize(formData[key].trim()) : formData[key];
        }
      });
      return storeObject;
    }
    /**
     * Form data is in the format:
     * {
     * 	`{sectionId}__{fieldId1}`: value,
     * 	`{sectionId}__{fieldId2}`: value
     * 	 }
     *
     * Store data is in the format:
     * {
     * 		sectionId: {
     * 			fieldId1`: value,
     * 			fieldId2`: value,
     * 		}
     * 	 }
     *
     * This utility will take a store data object and return a new object in the form format.
     *
     * @param {Object} storeData
     * @returns {Object}
     */

  }, {
    key: "storeToFormData",
    value: function storeToFormData(storeData) {
      var formData = {}; // Loop through each key in the storeData

      Object.keys(storeData).forEach(function (sectionKey) {
        if (storeData.hasOwnProperty(sectionKey)) {
          var section = storeData[sectionKey];

          if (!section) {
            return;
          }

          Object.keys(section).forEach(function (fieldKey) {
            if (section.hasOwnProperty(fieldKey)) {
              formData["".concat(sectionKey).concat(KEY_SEPERATOR).concat(fieldKey)] = storeData[sectionKey][fieldKey];
            }
          });
        }
      });
      return formData;
    }
  }, {
    key: "reduceFieldErrors",
    value: function reduceFieldErrors(accumulator, form, fieldName, errors) {
      if (!errors) {
        return accumulator;
      }

      try {
        //FIXME: This line sometimes throws errors when form fields are removed. i.e nested fields. Suspect race condition inside form.errors()
        //DO NOT remove the try catch until this resolved
        if (form.has(fieldName)) {
          // To check if field(s) is available in the form
          var field = form.$(fieldName);

          if (field.hasNestedFields) {
            // This will handle the error(s) for nested fields
            field.map(function (nestedField) {
              Object.entries(nestedField.errors() || []).filter(function (entry) {
                return !!entry[1];
              }) // Filter out null error values
              .forEach(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                    key = _ref2[0],
                    err = _ref2[1];

                return FormUtils.reduceFieldErrors(accumulator, nestedField, key, err);
              });
              return accumulator;
            });
          } else {
            if (_typeof(errors) === 'object' && !field.error) {
              Object.entries(errors).filter(function (entry) {
                return !!entry[1];
              }) // Filter out null error values
              .forEach(function (_ref3) {
                var _ref4 = _slicedToArray(_ref3, 2),
                    key = _ref4[0],
                    err = _ref4[1];

                return FormUtils.reduceFieldErrors(accumulator, form, "".concat(fieldName, ".").concat(key), err);
              });
              return accumulator;
            }
          }

          if (field.error) {
            accumulator.push([fieldName.replace(/(\[\d+])/, '[]'), {
              id: field.id,
              name: field.name,
              path: field.path,
              label: field.label,
              error: field.error
            }]);
          }
        }
      } catch (e) {
        console.error(e);
      }

      return accumulator;
    }
    /**
     * Fields with errors
     * @param form
     * @returns {[string , any]}
     */

  }, {
    key: "mapFormErrors",
    value: function mapFormErrors(form) {
      // Reduce error array to useful custom object models with error information
      return Object.entries(form.errors() || []).filter(function (entry) {
        return !!entry[1];
      }) // Filter out null values
      .reduce(function (accumulator, currentValue) {
        var _currentValue = _slicedToArray(currentValue, 2),
            fieldName = _currentValue[0],
            fieldErrors = _currentValue[1];

        return FormUtils.reduceFieldErrors(accumulator, form, fieldName, fieldErrors);
      }, []);
    }
    /**
     * Trims field values based on list of field names passed
     * @param {object} field
     * @param {array} fieldNames
     * @returns string
     */

  }, {
    key: "trimFieldValue",
    value: function trimFieldValue(field, fieldNames) {
      var fieldValue = typeof field.value === 'string' && field.value.length > 0 && fieldNames.indexOf(field.name.toLowerCase()) >= 0;

      if (fieldValue) {
        return field.value.trim();
      } else {
        return field.value;
      }
    }
  }]);

  return FormUtils;
}();

exports.default = FormUtils;
//# sourceMappingURL=FormUtils.js.map